import * as React from "react"

const Heading2 = ({ className, children }) => {
  let classes = "text-4xl text-red font-fancy mb-4 lg:text-6xl " + className
  return (<h2 className={classes}>{children}</h2>)
}

export default Heading2
